import { render, staticRenderFns } from "./GridPagination.vue?vue&type=template&id=4fca4160"
import script from "./GridPagination.vue?vue&type=script&lang=js"
export * from "./GridPagination.vue?vue&type=script&lang=js"
import style0 from "./GridPagination.vue?vue&type=style&index=0&id=4fca4160&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports